import React from "react";
import { Toast } from "./Toast";

// Dispatch a toast event globally so any page can show notifications
export function triggerToast(message, type = "info", duration = 4000) {
  if (typeof window === "undefined") return;
  const detail = { message, type, duration };
  const evt = new CustomEvent("app:toast", { detail });
  window.dispatchEvent(evt);
}

export function useGlobalToast() {
  const show = React.useCallback((message, type = "info", duration = 4000) => {
    triggerToast(message, type, duration);
  }, []);
  return { show };
}

export default function GlobalToast() {
  const [toast, setToast] = React.useState({
    message: "",
    type: "info",
    duration: 4000,
  });

  React.useEffect(() => {
    if (typeof window === "undefined") return;
    const onToast = (e) => {
      const d = (e && e.detail) || {};
      if (!d || !d.message) return;
      setToast({
        message: d.message,
        type: d.type || "info",
        duration: d.duration || 4000,
      });
    };
    window.addEventListener("app:toast", onToast);
    return () => window.removeEventListener("app:toast", onToast);
  }, []);

  const clear = React.useCallback(() => {
    setToast({ message: "", type: "info", duration: 4000 });
  }, []);

  return (
    <Toast
      message={toast.message}
      type={toast.type}
      duration={toast.duration}
      onDone={clear}
    />
  );
}
